import React, { useState } from 'react';
import { cn, mergeClasses } from '#lib/helpers/class.js';

import { LinkIcon } from '@heroicons/react/24/outline';

export function SectionHeading(props) {
    const { id, subtext, children } = props;
    const [mouseOver, setMouseOver] = useState(false);
    return (
        <div
            id={id}
            className="border-b border-neutral-200"
            style={{
                scrollMarginTop: '70px'
            }}
        >
            <div className="flex items-center gap-x-1">
                <a
                    href={`#${id}`}
                    className="font-bold text-xl text-neutral-800"
                    onMouseOver={() => setMouseOver(true)}
                    onMouseLeave={() => setMouseOver(false)}
                >
                    {children}
                </a>
                <LinkIcon className={cn('w-4 h-4', mouseOver ? 'text-neutral-500' : 'hidden')} />
            </div>
            <p className="text-neutral-700 text-sm">{subtext}</p>
        </div>
    );
}

export function SubSectionHeading(props) {
    const { subtext, children } = props;
    return (
        <div>
            <h3 className="font-bold text-neutral-800">{children}</h3>
            <p className="text-neutral-700 text-sm">{subtext}</p>
        </div>
    );
}
